import setupAxios from './setup-axios';

export default function MonetizationAPI() {
  const axiosConfig = {
    baseURL: process.env.MONETIZATION_API_URL
  };

  const axios = setupAxios(axiosConfig);

  const api = {
    fetchSubscriptions() {
      return axios.get('/subscriptions').then(({ data }) => data);
    },

    createPayPalSubscription(selectedSubscription, payPalResponse, coupon = {}) {
      const url = '/subscriptions/paypal';
      const params = {
        monetization_subscription_id: selectedSubscription.id,
        response: payPalResponse,
        coupon_name: coupon && coupon.name
      };

      return axios.post(url, params, { withCredentials: true })
        .then(({ data }) => data);
    },

    createFreeSubscription(selectedSubscription, coupon = {}) {
      const url = '/subscriptions/free';
      const params = {
        monetization_subscription_id: selectedSubscription.id,
        coupon_name: coupon && coupon.name
      };

      return axios.post(url, params, { withCredentials: true })
        .then(({ data }) => data);
    },

    checkCoupon(name) {
      const url = '/subscriptions/check_coupon';
      const params = { name };

      return axios.post(url, params, { withCredentials: true })
        .then(({ data }) => data);
    }
  };

  return api;
}
